import { Colors } from "../constants/colors";

export default {
  variants: [
    {
      props: { color: "default" },
      style: {
        width: 36,
        height: 17,
        padding: 0,
        display: "flex",
        "& .MuiSwitch-switchBase": {
          padding: 2,
          "&.Mui-checked": {
            transform: "translateX(19px)",
            color: Colors.WHITE,
            "& + .MuiSwitch-track": {
              opacity: 1,
            },
          },
          "& .MuiSwitch-thumb": {
            boxSizing: "border-box",
            width: 12,
            height: 12,
            borderRadius: 6,
            border: `1px solid ${Colors.GREY350}`,
          },
        },
        "& .MuiSwitch-track": {
          borderRadius: 16 / 2,
          opacity: 1,
          backgroundColor: Colors.GREY250,
          boxSizing: "border-box",
          border: `1px solid ${Colors.WHITE}`,
        },
        "& .MuiSwitch-switchBase.Mui-disabled": {
          "& .MuiSwitch-thumb": {
            backgroundColor: Colors.GREY250,
          },
          "& .MuiSwitch-track": {
            opacity: 1,
            backgroundColor: Colors.GREY450,
          },
        },
      },
    },
  ],
};